import { StyledVerticalScrollFade } from "./fade-vertical-scroll.styles";
import { MDSVerticalScrollFadeProps } from "./fade-vertical-scroll.types";

export const MDSFadeBottom = ({
  animateOpacity = true,
  visible = true,
  ...rest
}: Omit<MDSVerticalScrollFadeProps, "placement">) => (
  <StyledVerticalScrollFade
    data-mds-name="fade-bottom"
    $animateOpacity={animateOpacity}
    $placement="bottom"
    $visible={visible}
    aria-hidden
    {...rest}
  />
);
